import { createContext } from 'react';

export type NotificationSeverity = 'success' | 'info' | 'warning' | 'error';

export interface NotificationState {
  message: string | null;
  severity: NotificationSeverity;
  open: boolean;
  autoHideDuration?: number;
}

export interface NotificationContextValue {
  showNotification: (message: string, severity?: NotificationSeverity, duration?: number) => void;
  hideNotification: () => void;
  notification: NotificationState;
}

export const NotificationContext = createContext<NotificationContextValue | undefined>(undefined);
